import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

import useStyles from './useStyles';

const AccountNotFound = () => {
  const classes = useStyles();

  const navigate = useNavigate();

  const handleCreateAccountClick = () => {
    window.location.href = '/r2/registration-pbf/init';
  };

  const handleLogInClick = () => {
    navigate('/d/logout');
  };

  return (
    <section className={classes.root}>
      <Grid
        alignItems="center"
        container
        direction="column"
        justifyContent="flex-start"
        spacing={2}
      >
        <Grid item xs>
          <Title
            className={classes.heading1}
            level={1}
            variant="lg-alt"
          >
            Account not found
          </Title>
          <Text className={classes.paragraph}>
            Please use your email and password to log in.
            Or, create an account by forming a business.
          </Text>
        </Grid>
        <Grid item xs className={classes.btnWrap}>
          <Button
            className={classes.btn}
            size="large"
            variant="outlined"
            onClick={handleCreateAccountClick}
          >
            Create an account
          </Button>
          <Button
            className={`${classes.btn} ${classes.btnRight}`}
            size="large"
            onClick={handleLogInClick}
          >
            Log in
          </Button>
        </Grid>
        <Grid item xs>
          <SharedAsset
            alt="Account not found"
            className={classes.img}
            height={256}
            src="/icon/product/no-documents.svg"
            width={256}
          />
        </Grid>
      </Grid>
    </section>
  );
};

export default AccountNotFound;
